import React, { useState, useEffect, useCallback } from "react";
import {
  TopToolbar,
  RefreshButton,
  ReferenceField,
  TextField,
  SelectInput,
  DateField,
  ListButton,
  ShowButton,
  Edit,
  SimpleForm,
  SaveButton,
  Toolbar,
  useTranslate,
  useRecordContext,
  useGetOne,
  TextInput,
  required,
  useNotify,
  useRefresh,
  useRedirect,
} from "react-admin";
import Select from "react-select";
import AsyncSelect from 'react-select/async';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import { useLocation, useNavigate } from "react-router-dom";
import debounce from "lodash.debounce";
import _ from "lodash";

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const EditActions = ({ basePath, data }) => (
  <TopToolbar>
    <RefreshButton />
    <ListButton basePath={basePath} />
    <ShowButton basePath={basePath} record={data} />
  </TopToolbar>
);

const EditTitle = ({ record }) => {
  const translate = useTranslate();

  return (
    <span>
      {translate("resources.users.fields.edit_user")}{" "}
      {record ? `${record.first_name}` : ""}
    </span>
  );
};

const PostEditToolbar = (props) => (
  <Toolbar {...props}>
    <div className="so-save-button">
      <button onClick={props.submitfun}             
        disabled={
          !props.phoneNumber ||
          !props.firstName ||
          !props.lastName ||
          !props.email ||
          props.emailError ||
          !Object.keys(props.businessRole).length ||
          !Object.keys(props.businessId).length ||
          props.businessRole.value == 'contract_person' && !Object.keys(props.contractList).length
        } 
      >  SAVE</button>
    </div>
  </Toolbar>
);

const UserSignUpEdit = ({ permissions, ...props }) => {
  const translate = useTranslate();
  const location = useLocation();
  const path = location?.pathname.split("/");
  const { data } = useGetOne("clickit_signup_customers", { id: path[2] });
  const [saleOffNameSapCode, setSaleOffNameSapCode] = useState([]);
  const [businessError, setBusinessError] = useState(false);
  const [originalList, setOriginalList] = useState([]);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [email, setEmail] = useState("");

  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [phoneErrorMsg, setPhoneErrorMsg] = useState(null);

  const [emailError, setEmailError] = useState(false);

  const [similarNumberError, setSimilarNumberError] = useState(false);
  const [similarNumberMsg, setSimilarNumberMsg] = useState("");

  const [similarEmailError, setSimilarEmailError] = useState(false);
  const [similarEmailMsg, setSimilarEmailMsg] = useState("");

  const [soldToError, setSoldToError] = useState(false);
  const [noOrderFound, setNoOrderFound] = useState(true);

  const [businessId, setBusinessId] = useState([]);

  const [businessListPage, setBusinessListPage] = useState(1);
  const [businessListPagination, setBusinessListPagination] = useState(true);
  const [businessListLoading, setBusinessListLoading] = useState(false);

  console.log("businessId", data, businessId);

  const [businessRole, setBusinessRole] = useState({});
  const [businessRoleError, setBusinessRoleError] = useState(false);
  const rolesOption = [
    { value: "contract_person", label: "Contract Person" },
    { value: "owner", label: "Owner" },
    { value: "view_only", label: "View Only"}
  ];
  const [contractListOption, setContractListOption] = useState([]);
  const [contractListOGOption, setContractListOGOption] = useState([]);
  const [contractList,setContractList] = useState([]);
  const [contractError,setContractError] = useState(false);
  const [status,setStatus] = useState(false);
  const [contractListPage, setContractListPage] = useState(1);
  const [contractListPagination, setContractListPagination] = useState(true);

  const [debounceSearchKey,setDebounceSearchKey] =useState('')

  useEffect(() => {
    setPhoneNumber(data?.mobile);
    setFirstName(data?.first_name);
    setLastName(data?.last_name);
    setEmail(data?.email);
    // const businessData = data?.businesses.map((item) => ({
    //   id: item.id,
    //   value: item.label,
    //   label: item.label,
    //   sap_code: item.sap_code,
    // }));
    // setBusinessId(businessData);
    // const roleData = data?.role_name == "contract_person" ? 
    //     { value: "contract_person", label: "Contract Person" } :
    //         data?.role_name == "owner" ? { value: "owner", label: "Owner" } : data?.role_name == "view_only" ?
    //             { value: "view_only", label: "View Only" } : { value: "employee", label: "Sales Person" } ;
    // setBusinessRole(roleData);
    // setStatus(data?.status)
    // setContractList(
    //   data?.contracts.map((item) => ({
    //       id: item.id,
    //       value: item.label,
    //       label: item.label,
    //       sap_code: item.sap_code.trim(),
    //   }))
    // );
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    // fetch(`${apiUrl}/clickit_business_list`, options)
    //   .then((res) => {
    //     return res.json();
    //   })
    //   .then((jsonD) => {
    //     console.log("jsonD ===>", jsonD);
    //     let obj = {};
    //     obj.sap_order_materials = jsonD.data;
    //     obj.loadingShow = false;

    //     let res = jsonD.data;

    //     setOriginalList(
    //         res.map((item) => ({
    //         id: item.id,
    //         value: item.label,
    //         label: item.label,
    //         sap_code: item.sap_code,
    //         name: item.name,
    //         user_name: item.user_name,
    //         phone: item.phone,
    //         locale: item.locale,
    //         address: item.address,
    //       }))
    //     );

    //     setSaleOffNameSapCode(
    //         res.map((item) => ({
    //         id: item.id,
    //         value: item.label,
    //         label: item.label,
    //         sap_code: item.sap_code.trim(),
    //         name: item.name,
    //         user_name: item.user_name,
    //         phone: item.phone,
    //         locale: item.locale,
    //         address: item.address,
    //       }))
    //     );
    //   });
    const fetchBusinessList = (page) => {
      fetch(`${apiUrl}/clickit_business_list?page=${page}`, options)
        .then((res) => res.json())
        .then((jsonD) => {
          const res = jsonD.data;
          
          // Map new results
          const newResults = res.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap_code: item.sap_code,
            name: item.name,
            user_name: item.user_name,
            phone: item.phone,
            locale: item.locale,
            address: item.address,
          }));
  
          // Update lists based on pagination
          if (page === 1) {
            setOriginalList(newResults);
            setSaleOffNameSapCode(newResults);
          } else {
            // Append new results for subsequent pages
            setOriginalList(prev => [...prev, ...newResults]);
            setSaleOffNameSapCode(prev => [...prev, ...newResults]);
          }
  
          // Check if there are more pages
          setBusinessListPagination(jsonD.pagination && jsonD.pagination);
        })
        .catch(error => {
          console.error("Error fetching business list:", error);
          setBusinessListPagination(false);
        });
    };
    fetchBusinessList(businessListPage);
  }, [data,businessListPage]);

  // Function to remove similar objects from the second array
  const removeSimilarObjects = (arr1, arr2) => {
    return arr2.filter(item2 => !arr1.some(item1 => item1.id === item2.id));
  };

  // Function to add unique objects from array1 to array2
  const addUniqueObjects = (arr1, arr2) => {
    arr1.forEach(item1 => {
      const existsInArray2 = arr2.some(item2 => item2.id === item1.id);
      if (!existsInArray2) {
        arr2.push(item1);
      }
    });
  };


  // useEffect(() => {
  //   // if(businessId && Object.keys(businessId).length >0 && (Object.keys(businessRole).length >0 && businessRole.value == 'contract_person')) 
  //   if (businessId && businessId.id && businessRole && businessRole.value === 'contract_person')
  //   {
  //     setContractListOption([])
  //     console.log('uspppppppppp',businessId);

  //     const options = CommonHeaderOption();
  //     const apiUrl = RUN_TIME_API_ENDPOINT;
  //     options.method = "GET";
  //     fetch(`${apiUrl}/clickit_contract_list?business=${businessId.id}`, options)
  //       .then((res) => {
  //         return res.json();
  //       })
  //       .then((jsonD) => {
  //         console.log("jsonD ===>", jsonD);
  //         if (jsonD?.data.length > 0) {
  //           let obj = {}; 
  //           // obj.contracts = jsonD.data;
  //           obj.loadingShow = false;


  //           const contractListFromApi = jsonD.data.map((item) => ({
  //               id: item.id,
  //               value: item.label,
  //               label: `${item.label} : ${item.contract_valid_from}:${item.contract_valid_to}`,
  //               contract_number: item.contract_number,
  //               sales_company_number: item.sales_company_number,
  //               contract_valid_from: item.contract_valid_from,
  //               contract_valid_to: item.contract_valid_to,
  //               incoterm: item.incoterm,
  //               sap_code: item.sap_code
  //           }))

  //           setContractListOGOption(contractListFromApi);

  //           const filteredArray2 = removeSimilarObjects(contractList, contractListFromApi);
  //           setContractListOption(filteredArray2)
  //           }
  //       });
  //   }

  // }, [businessId,businessRole]);

  useEffect(() => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";

    const fetchContractList = (page) => {
      const fetchUrl = debounceSearchKey 
        ? `${apiUrl}/clickit_contract_list?business=${businessId.id}&contract=${debounceSearchKey}&page=${page}`
        : `${apiUrl}/clickit_contract_list?business=${businessId.id}&page=${page}`;

        // const fetchUrl = `${apiUrl}/clickit_contract_list?business=${businessId.id}&contract=${inputValue}&page=${contractListPage}`
  
      fetch(fetchUrl, options)
        .then(res => res.json())
        .then(json => {
          const mappedContracts = mapOptionsToValuesForContract(json.data);
          
          // Update pagination state
          if (!json.data.length || !json.pagination) {
            setContractListPagination(false);
          }
          
          // For first page, reset options
          if (page === 1) {
            // setContractListOption(mappedContracts);
            setContractListOGOption(mappedContracts);

            const filteredArray2 = removeSimilarObjects(contractList, mappedContracts);
            setContractListOption(filteredArray2)
          } else {
            // Append new results for subsequent pages
            setContractListOption(prev => [...prev, ...mappedContracts]);
            setContractListOGOption(prev => [...prev, ...mappedContracts]);
          }
          
        })
        .catch(error => {
          console.error('Contract list fetch error:', error);
          setContractListPagination(false);
        });
    };

    if (businessId && businessId.id && businessRole && businessRole.value === 'contract_person'){
      console.log('getting hit ?>>>>>>>>>>>');
      fetchContractList(contractListPage,debounceSearchKey);
    }
  }, [data,businessId,businessRole,contractListPage,debounceSearchKey]);

  const handleChangeContracts = (e) => {
    console.log("hiiii handleChangeContracts", e);
    setContractError(false);
    setContractList(e);
    // console.log("saleOffNameSapCode in handleChange", saleOffNameSapCode);
    const arr = [...contractListOGOption];

    const theRemovedObject = removeSimilarObjects(e,arr);

    const newPushedArray = addUniqueObjects(theRemovedObject,contractListOption);
    // console.log('newPushedArray',newPushedArray);

    if (Array.isArray(e)) {
      const newOptions = e
        .filter((item) => !contractListOption.some((option) => option.id === item.id)) // Filter out duplicates
        .map((item) => ({
          id: item.id,
          value: item.label,
          label: item.label.includes(`${item.contract_valid_from}:${item.contract_valid_to}`)
            ? item.label
            : `${item.label} : ${item.contract_valid_from}:${item.contract_valid_to}`,
          contract_number: item.contract_number,
          sales_company_number: item.sales_company_number,
          contract_valid_from: item.contract_valid_from,
          contract_valid_to: item.contract_valid_to,
          incoterm: item.incoterm,
          sap_code: item.sap_code
        }));
    
      setContractListOption((prevOptions) => [...newOptions, ...prevOptions]); // Add new options at the top
    }

  };

  const handleChange = (e) => {
    console.log("hiiii handleChange", e , contractList);
    setContractList([])
    setContractListOption([]);

    if (
      e &&
      !saleOffNameSapCode.some((option) => option.sap_code === e.sap_code)
    ) {
      const newOption = {
        id: e.id,
        value: e.label,
        label: e.label,
        sap_code: e.sap_code.trim(),
        name: e.name,
        user_name: e.user_name,
        phone: e.phone,
        locale: e.locale,
        address: e.address,
      };
  
      setSaleOffNameSapCode((prevOptions) => [newOption,...prevOptions]);
    }


    setBusinessError(false);
    setBusinessId(e);
  };


  const cancelClick = () => {
    // setBusiness([]);
    setBusinessId({});
    setBusinessError(true);
    // setSaleOffNameSapCode(originalList);
  };

  const handleChangeRole = (e) => {
    console.log("hiiii", e);
    setBusinessRoleError(false);
    setBusinessRole(e);
    setContractList([]);
  };

  const transform = (data) => ({
    ...data,
    businesses: businessId,
  });

  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onSuccess = (data) => {
    console.log("data =>", data);
    notify(`Changes saved`);
    // redirect('/posts');
    // refresh();
  };

  const handleFormSubmit = (e) => {
    //   alert('submit');
    e.preventDefault();

    const businessIdToArray = Array.isArray(businessId) ? businessId : [businessId];
    
    if (phoneNumber === "" || phoneNumber === null) {
      setPhoneNumberError(true);
      setPhoneErrorMsg("Enter Phone number");
    } else if (businessIdToArray.length === 0) {
      setSoldToError(true);
    } else if (phoneNumber.length < 7 || phoneNumber.length > 15) {
      setPhoneNumberError(true);
      setPhoneErrorMsg("Phone number should be min 7 and max 15 digit");
    } else if(businessRole.value == 'contract_person' && contractList.length <= 0){
      setContractError(true);
    } else {
      setPhoneNumberError(false);
      setSoldToError(false);
      const options = CommonHeaderOption();
      const apiUrl = RUN_TIME_API_ENDPOINT;
      let req = {
        ...data,
        businesses: businessIdToArray,
        mobile: phoneNumber,
        role_name: businessRole.value,
        contract_list: contractList,
        email:email
      };
      console.log("req", req);
      options.method = "PATCH";
      options.body = JSON.stringify(req);
      fetch(`${apiUrl}/clickit_signup_customers/${data.id}`, options)
      .then((res) => {
        // return res.json();
        return new Promise((resolve) =>
          res.json().then((json) =>
            resolve({
              status: res.status,
              json,
            })
          )
        );
      })
        .then(({json, status}) => {
          console.log("jsonD ===>", json);
          // navigate("/terms_and_condition_list");
          // if (jsonD.status === false) {
          //   notify(jsonD.message);
          // } else {
          //   notify(jsonD.message);
          //   redirect("/clickit_signup_customers");
          //   refresh();
          // }

          // navigate("/terms_and_condition_list");
          switch (status) {
            case 400:
            case 409:
              console.log("error", json);
              if (json.type == "Phone") {
                setSimilarNumberError(true);
                setSimilarNumberMsg(json.message);
              } else {
                setSimilarEmailError(true);
                setSimilarEmailMsg(json.message);
              }
              break;
            case 201:
            case 200:
              notify(json.message);
              redirect("/clickit_signup_customers");
              refresh();
              break;
            default:
              console.log("default", status);
              break;
          }
        });
    }
  };

  const debouncedBusinessLoadOptions = useCallback(
    debounce((inputValue, callback) => {
      if (!inputValue) {
        // If no input, return original list
        callback(saleOffNameSapCode);
        return;
      }
  
      const options = CommonHeaderOption();
      const apiUrl = RUN_TIME_API_ENDPOINT;
      options.method = 'GET';
      
      fetch(`${apiUrl}/clickit_business_list?business=${inputValue}&page=${1}`, options)
        .then(res => res.json())
        .then(json => {
          const filteredOptions = mapOptionsToValues(json.data);
          
          // Update pagination state
          if (!json.data.length || !json.pagination) {
            setBusinessListPagination(false);
          }
          setDebounceSearchKey('');
          callback(filteredOptions);
        })
        .catch(error => {
          console.error('Error in business options:', error);
          setDebounceSearchKey('');
          callback([]);
        });
    }, 500),
    [businessListPage, saleOffNameSapCode]
  );

  // const debouncedBusinessLoadOptions = useCallback(
  //   debounce((inputValue, callback) => {
  //     businessOptions(inputValue).then(callback);
  //   }, 500), // 500ms delay
  //   [businessListPage]
  // );

  const businessOptions = q =>{
    console.log('hhhhhhhhhhhhhhhhhhhhhhhhhhhh',q);
    if (!q) {
        setNoOrderFound(true);
        return saleOffNameSapCode;
    }
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = 'GET';
    // options.body = JSON.stringify({order_number: q,});
    const _url = `${apiUrl}/clickit_business_list?business=${q}`;
    // const _url =  `${apiUrl}/sap_digital_app_orders?filter=%7B"business_id"%3A${businessId}%2C"order_number"%3A%22${q}%22%7D`;
    return new Promise(resolve => {
        fetch(_url, options)
        .then(res => {
            return res.json();
        })
        .then(json => {
            console.log('.k.k.kk', json);
            // setNoOrderFound(json.order_exist);
            resolve(mapOptionsToValues(json.data));
        }).catch((error) => {
            console.log('error==>', error);
        });
    });
  }

  const mapOptionsToValues = options => {
    console.log('.../////......//..',options);
    return options.map(option => ({
        id: option.id,
        value: option.label,
        label: option.label,
        sap_code: option.sap_code.trim(),
        name: option.name,
        user_name: option.user_name,
        phone: option.phone,
        locale: option.locale,
        address: option.address,
    }));
  };

  const handleScrollToBottomBusinessList = () => {
    if (businessListPagination) {
      setBusinessListPage((prevPage) => prevPage + 1);
    }
  };

  const debouncedContractLoadOptionsa = useCallback(
    debounce((inputValue, callback) => {
      if (!businessId || !businessId.id) {
        callback([]);
        return;
      }
  
      const options = CommonHeaderOption();
      const apiUrl = RUN_TIME_API_ENDPOINT;
      options.method = 'GET';

      console.log('160904 inputValue',inputValue);
      
      
      const fetchUrl = inputValue 
        ? `${apiUrl}/clickit_contract_list?business=${businessId.id}&contract=${inputValue}&page=${contractListPage}`
        : `${apiUrl}/clickit_contract_list?business=${businessId.id}&page=${contractListPage}`;

        // const fetchUrl = `${apiUrl}/clickit_contract_list?business=${businessId.id}&contract=${inputValue}&page=${contractListPage}`
  
      fetch(fetchUrl, options)
        .then(res => res.json())
        .then(json => {
          const mappedContracts = mapOptionsToValuesForContract(json.data);
          
          // Update pagination state
          if (!json.data.length || !json.pagination) {
            setContractListPagination(false);
          }
          
          // For first page, reset options
          if (contractListPage === 1) {
            setContractListOption(mappedContracts);
            setContractListOGOption(mappedContracts);
          } else {
            // Append new results for subsequent pages
            setContractListOption(prev => [...prev, ...mappedContracts]);
            setContractListOGOption(prev => [...prev, ...mappedContracts]);
          }
          
          callback(mappedContracts);
        })
        .catch(error => {
          console.error('Contract list fetch error:', error);
          callback([]);
        });
    }, 500),
    [businessId, contractListPage]
  );
  
  const handleScrollToBottomContractList = () => {
    if (contractListPagination) {      
      setContractListPage((prevPage) => prevPage + 1);
    }
  };

  const debouncedContractLoadOptions = useCallback(
    debounce((inputValue, callback) => {
      setDebounceSearchKey(inputValue);
      contractOptions(inputValue).then(callback);
    }, 500), // 500ms delay
    [businessId]
  );

  const contractOptions = q =>{
    if (!q) {
        setNoOrderFound(true);
        return saleOffNameSapCode;
    }
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = 'GET';
    // options.body = JSON.stringify({order_number: q,});
    const _url = `${apiUrl}/clickit_contract_list?business=${businessId.id}&contract=${q}`;
    // const _url =  `${apiUrl}/sap_digital_app_orders?filter=%7B"business_id"%3A${businessId}%2C"order_number"%3A%22${q}%22%7D`;
    return new Promise(resolve => {
        fetch(_url, options)
        .then(res => {
            return res.json();
        })
        .then(json => {
            console.log('.k.k.kk', json);
            // setNoOrderFound(json.order_exist);
            resolve(mapOptionsToValuesForContract(json.data));
        }).catch((error) => {
            console.log('error==>', error);
        });
    });
  }

  const mapOptionsToValuesForContract = options => {
    console.log('.../////......//..',options);
    return options.map(option => ({
      id: option.id,
      value: option.label,
      label: `${option.label} : ${option.contract_valid_from}:${option.contract_valid_to}`,
      contract_number: option.contract_number,
      sales_company_number: option.sales_company_number,
      contract_valid_from: option.contract_valid_from,
      contract_valid_to: option.contract_valid_to,
      incoterm: option.incoterm,
      sap_code: option.sap_code
    }));
  };

  const changeFirstName = (event) => {
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length
    ) {
      setFirstNameError(true);
    } else {
      setFirstNameError(false);
    }
    setFirstName(positionObject);
  };

  const changeLastName = (event) => {
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length
    ) {
      setLastNameError(true);
    } else {
      setLastNameError(false);
    }
    setLastName(positionObject);
  };

  const changePhoneNumber = (event) => {
    const pattern = new RegExp(/^[0-9\b]+$/);
    const reg = new RegExp("^d+$");
    const textValidation = /^\d+$/.test(event.target.value) == true ;
    
    setSimilarNumberError(false);
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length ||
      !textValidation ||
      reg.test(positionObject)
    ) {
      setPhoneNumberError(true);
      setPhoneErrorMsg("Enter Phone number");
    } else {
      setPhoneNumberError(false);
      setPhoneErrorMsg(null);
    }
    setPhoneNumber(positionObject);
  };

  const changeEmail = (event) => {
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    setSimilarEmailError(false);
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length ||
      !pattern.test(positionObject)
    ) {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
    setEmail(positionObject);
  };


  return (
    <Edit
      actions={<EditActions />}
      title={<EditTitle />}
      {...props}
      // transform={transform}
      // mutationMode='pessimistic'
      // mutationOptions={{ onSuccess }}
    >
      <SimpleForm
        toolbar={<PostEditToolbar submitfun={(e) => handleFormSubmit(e)} emailError={emailError} businessRole={businessRole} firstName={firstName} lastName={lastName} email={email} phoneNumber={phoneNumber} businessId={businessId} contractList={contractList} />}
      >
        <label className="select-label">
          {translate('resources.users.fields.role')}<sup>*</sup>
          </label>
          <div className="select-retailer">
            <Select
            //   value={businessRole}
              onChange={handleChangeRole}
            //   isDisabled={data?.role_name == 'employee' || data?.role_name == 'Employee'}
              options={rolesOption}
              isMulti={false}
              required={true}
              IndicatorsContainer={true}
            />
            {/* <button onClick={cancelClick}>{translate('resources.users.fields.clear')}</button> */}
          </div>
          {businessRoleError && <p className="so-input-error">Enter Business Role</p>}
        <div className="ecu-select">
          <label className="select-label">
            {translate("resources.users.fields.sold_to")}
            <sup>*</sup>
          </label>
          <div className="select-retailer">
            <AsyncSelect
              value={businessId}
              onChange={handleChange}
              defaultOptions={saleOffNameSapCode}
              isMulti={false}
              source="businesses"
              required={true}
              IndicatorsContainer={true}
              loadOptions={debouncedBusinessLoadOptions}
              onMenuScrollToBottom={handleScrollToBottomBusinessList}
              placeholder="Select..."
              isLoading={businessListLoading} 
            />
            {/* <button onClick={cancelAsyncClick}>Clear</button> */}
            {soldToError && (
              <p className="complaint-file-error">Field cant be empty</p>
            )}
            {/* <button onClick={cancelClick}>
              {translate("resources.users.fields.clear")}
            </button> */}
          </div>
          {businessError && <p className="complaint-file-error">Enter Business Id</p>}
        </div>

        {
          // (businessId && Object.keys(businessId).length >0 &&(Object.keys(businessRole).length > 0 && businessRole.value == 'contract_person')) &&
          (businessId && businessId.id && businessRole && businessRole.value === 'contract_person') &&
          <><label className="select-label">
          {translate('resources.users.fields.contracts')}<sup>*</sup>
          </label>
          <div className="select-retailer">
            <AsyncSelect
              value={contractList}
              onChange={handleChangeContracts}
              defaultOptions={contractListOption}
              isMulti={true}
              required={true}
              IndicatorsContainer={true}
              loadOptions={debouncedContractLoadOptions}
              cacheOptions
              placeholder="Select..."
              onMenuScrollToBottom={handleScrollToBottomContractList}
            />
            {/* <button onClick={cancelClick}>{translate('resources.users.fields.clear')}</button> */}
            {contractError && <p className="complaint-file-error">Enter Contracts</p>}
          </div>
          </>
        }

        {/* <div className="ecu-item-row"> */}
          {/* <div className="ecu-item"> */}
            <div className="so-input ecu-phone">
              <label className="select-label" >
                {translate("resources.users.fields.first_name")}
                <sup>*</sup>
              </label>
                <input type="text" value={firstName} onChange={changeFirstName} />
              {firstNameError && <p className="so-input-error">Enter first name</p>}
            </div>
          {/* </div> */}
          {/* <div className="ecu-item"> */}
            <div className="so-input ecu-phone">
              <label className="select-label">
                {translate("resources.users.fields.last_name")}
                <sup>*</sup>
              </label>
                <input type="text" value={lastName} onChange={changeLastName} />
              {lastNameError && <p className="so-input-error">Enter Last name</p>}
            </div>
          {/* </div> */}
        {/* </div> */}

        {/* <label className="select-label">
          {" "}
          {translate("resources.users.fields.phone")}{" "}
        </label> */}

        {/* <TextField source="phone" /> */}
        {/* <div className="ecu-item-row"> */}
          {/* <div className="ecu-item"> */}
            {/* <TextInput type="number" source="phone" validate={[required()]} /> */}
            <div className="so-input ecu-phone">
            <label>
              {translate("resources.users.fields.phone")}
              <sup>*</sup>
            </label>
            <input
              type="text"
              min="7"
              maxLength="18"
              value={phoneNumber}
              onChange={changePhoneNumber}
            />
            {phoneNumberError && (
              <p className="so-input-error">{phoneErrorMsg}</p>
            )}

            {similarNumberError && (
            <p className="so-input-error">{similarNumberMsg}</p>
          )}
          </div>
          {/* </div> */}
          {/* <div className="ecu-item"> */}
          <div className="so-input ecu-phone">
            <label>
              {translate("resources.users.fields.email")}
              <sup>*</sup>
            </label>
              <input type="email" value={email} onChange={changeEmail} />
            {emailError && <p className="so-input-error">Enter Email</p>}

            {similarEmailError && (
              <p className="so-input-error">{similarEmailMsg}</p>
            )}
          </div>
          {/* </div> */}
        {/* </div> */}

        <div className="ecu-item-row">
          <div className="ecu-item">
            <label className="select-label">
              {translate("resources.users.fields.created_at")} :
            </label>
            &nbsp;
            <DateField
              // label={"Created at"}
              source="created_at"
              showTime
            />
          </div>
          <div className="ecu-item">
            <label className="select-label">
              {translate("resources.users.fields.updated_at")} :
            </label>
            &nbsp;
            <DateField label={"Updated at"} source="updated_at" showTime />
          </div>
        </div>
      </SimpleForm>
    </Edit>
  );
};

export default UserSignUpEdit;
